/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_No_CapabilityInputs */

const en_dispatch_no_capability = /** @type {(inputs: Dispatch_No_CapabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This fleet supports no task`)
};

const fr_dispatch_no_capability = /** @type {(inputs: Dispatch_No_CapabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette flotte ne supporte aucune tâche`)
};

const ms_sg2_dispatch_no_capability = /** @type {(inputs: Dispatch_No_CapabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armada ini tidak menyokong sebarang tugasan`)
};

/**
* | output |
* | --- |
* | "This fleet supports no task" |
*
* @param {Dispatch_No_CapabilityInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_no_capability = /** @type {((inputs?: Dispatch_No_CapabilityInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_No_CapabilityInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_no_capability(inputs)
	if (locale === "fr") return fr_dispatch_no_capability(inputs)
	return ms_sg2_dispatch_no_capability(inputs)
});